import styled from 'styled-components';

export const FormWrapper = styled.div`
  padding-top: 8px;
  padding-bottom: 24px;
`;
